import React, { memo } from 'react';
import { Label } from '../../components/LabelComponent/Label';

export const CommentFormHeader: React.FC<{ labelProps: any }> = memo(
  ({ labelProps }) => {
    return (
      <div className="comment-form__header">
        <Label {...labelProps} />
      </div>
    );
  }
);
